import React from "react";

import Figure from "../../figures/Figure";


export default function ({shouldShow, previews}) {
    return shouldShow ? Object.keys(previews).map(uuid =>
        <Figure key={`${previews[uuid].get("uuid")}-preview`} figure={previews[uuid]} kind={"separate"}/>
    ) : null;
}